// Dados estáticos.
import {
  PROFILE_LOCATION,
  PROFILE_API_BASE,
  QUERY_ACCESS,
  CATEGORY_LOCATION,
} from "../static/URL";
// Bibliotecas de utilidade.
import api from "../utils/API";

/**
 * Método para carregar as categorias.
 *
 * @param {String} orderId Id do pedido
 * @param {String} token token de autenticação
 */
export const loadCategory = async (profileId, token) => {
  try {
    const { data: categories } = await api.get(
      `${PROFILE_API_BASE + PROFILE_LOCATION}/${
        profileId + CATEGORY_LOCATION
      }?${QUERY_ACCESS + token}`
    );
    return categories;
  } catch (error) {
    console.log({ ...error });
    return [];
  }
};
